import React, { useState, useEffect} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';

import { 
    Layout,
    Col, 
    Row,
    // Dropdown, 
    // Space,
    // Modal,
    Space,
} from 'antd';
import { 
  useNavigate,  
  useParams 
} from 'react-router-dom';
import {
  ArrowBack,
} from '@mui/icons-material';
// import { ExclamationCircleFilled } from '@ant-design/icons';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatDate } from '../../Utils/Common';

// const { confirm } = Modal;

const TenantHistory = () => {
  const navigate = useNavigate()
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  // const [filterConfig, setFilterConfig] = useState({
  //   // user_id: '',
  //   tenant_id: id,
  // })
  const [historyData, setHistoryData] = useState([])

  async function fetchHistoryData() {
    setIsLoading(true);

    const response = await UseGetRequest("tenants/rate_history", {tenant_id: id});
    if (response.data) {
      const data = response.data.data.map((info) => ({
        ...info,
        status_date: info.status_date ? formatDate(info.status_date) : '',
      }))
      setHistoryData(data);
    } else {
      setHistoryData([])
    }

    setIsLoading(false);
  }

  useEffect(() => {
    fetchHistoryData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
      <Layout className='page'>
          <Navbar/>
          <Layout className='content-container'>
            <Row className='custom-padding responsive-inline responsive-tab-inline'>
              <Col span={24} className='header-container'>
                    <Space>
                        <ArrowBack className='cursor' onClick={() => navigate(-1)}/>
                        TENANT HISTORY
                    </Space>
                </Col>
            </Row>
            <Row className='page-content'>
              <Col span={24} className='responsive-overflow-auto'>
                <AntDTable
                  tableHeaders={[
                    "Description",
                    "Lease Term",
                    "Escalation Year",
                    "Escalation",
                    "Space Rental Rate",
                    "Alfresco Rental Rate",
                    "Cusa Rental Rate",
                    "Status",
                    "Updated On",
                    "Updated By",
                  ]}
                  headerSelector={[
                    "contract_date",
                    "lease_term",
                    "year",
                    "escalation",
                    "space",
                    "alfresco",
                    "cusa",
                    "status",
                    "status_date",
                    "updated_by",
                  ]}

                  tableData={historyData}
                  withAction={false}
                  loading={isLoading}
                  // isClickable={true}
                  // rowClickPath={"/patients/profile"}
                  tablePages={10}
                  // handleTableChange={handleTableChange}
                  // filterConfig={filterConfig}
                  // totalSize={totalSize}
                  isSearch={true}
                />
              </Col>
            </Row>
          </Layout>
      </Layout>
  )
}

export default TenantHistory
